import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Zap, Shield, RefreshCw, Crown } from "lucide-react";
import DealForgeLogo from "../components/DealForgeLogo";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ActivateSubscriptionPage({ user, onLogout }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleActivate = async () => {
    setLoading(true);
    try {
      // Ensure investor portal is selected
      await axios.post(
        `${BACKEND_URL}/api/subscription/select-portals`,
        { primary_portal: "investor", additional_portals: [] },
        { withCredentials: true }
      );
      const res = await axios.post(
        `${BACKEND_URL}/api/subscription/create-checkout`,
        {},
        { withCredentials: true }
      );
      if (res.data.checkout_url) {
        window.location.href = res.data.checkout_url;
      }
    } catch (err) {
      console.error("Checkout error:", err);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4">
      <div className="mb-8">
        <DealForgeLogo size="sm" showTM />
      </div>

      <div className="w-full max-w-md bg-[#0A0A0A] border border-white/[0.08] rounded-2xl p-8 text-center">
        <div className="w-16 h-16 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center mx-auto mb-6">
          <Zap className="w-8 h-8 text-[#D4AF37]" />
        </div>

        <h1 className="text-2xl font-bold text-white mb-2">Activate Investor Access</h1>
        <p className="text-white/50 text-sm mb-6">
          You're ready to operate. Unlock full access to start closing deals inside the DealForge network.
        </p>

        <div className="bg-[#D4AF37]/5 border border-[#D4AF37]/20 rounded-xl p-4 mb-6 text-left space-y-3">
          <div className="flex items-center gap-3">
            <Crown className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
            <div>
              <p className="text-white text-sm font-medium">Founder Rate — $99/mo locked forever</p>
              <p className="text-white/40 text-xs">Pricing locked in permanently for beta founders</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Shield className="w-4 h-4 text-emerald-400 flex-shrink-0" />
            <div>
              <p className="text-white text-sm font-medium">Full Platform Access</p>
              <p className="text-white/40 text-xs">Every feature, every portal, every tool</p>
            </div>
          </div>
        </div>

        <Button
          onClick={handleActivate}
          disabled={loading}
          className="w-full h-12 bg-[#D4AF37] hover:bg-[#B8962E] text-black font-bold text-base mb-4"
          data-testid="activate-subscription-btn"
        >
          {loading ? (
            <><RefreshCw className="w-4 h-4 animate-spin mr-2" /> Redirecting...</>
          ) : (
            "Activate Investor Access"
          )}
        </Button>

        <button
          onClick={onLogout}
          className="text-white/30 hover:text-white/50 text-sm transition-colors"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
